<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/log")
          i.fa.fa-file
          span.ml-1 {{ $tc("ui.logs", 2) }}
      b-breadcrumb-item
        router-link(to="/log/mapleagueLog")
          i.fa.fa-history
          span.ml-1 {{ $t("ui.map_league_log") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      option(value=0)
                        | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.action_by") }}
                    DebounceInput(required type="text" v-model="actionBySearch")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="logSearch")
                div.col-md-2.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="league_id") {{ $t("ui.league_id") }}
                    b-form-radio(value="league_name") {{ $t("ui.league_name") }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.status") }}
                    b-form-select(v-model="statusSearch" autofocus)
                      option(value="") {{ $t("ui.all") }}
                      option(value="1") {{ $t("ui.success") }}
                      option(value="99") {{ $t("ui.failed") }}
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLog(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div(v-if="pageLvl == 'master'")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="auditLogTotalRow"
                  :per-page="getPageSize"
                  v-model="currentLogPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="auditLogTotalRow" readonly)
            div.row.clusterize
              div.col-md-12
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span {{ $t("ui.id") }}
                      th.sticky-position(width="15%")
                        span {{ $t("ui.status") }}
                      th.sticky-position(width="8%")
                        span {{ $t("ui.ip_address") }}
                      th.sticky-position(width="8%")
                        span {{ $tc("ui.sports", 1) }}
                      th.sticky-position(width="22%")
                        span {{ $t("ui.sbo_league") }}
                      th.sticky-position(width="22%")
                        span {{ $t("ui.ibc_league") }}
                      th.sticky-position(width="10%" @click="sortOrder('action_by')")
                        span {{ $t("ui.action_by") }}
                        i(:class="changeSortKey('action_by')")
                      th.sticky-position.text-right(width="10%" @click="sortOrder('created_on')")
                        span {{ $t("ui.created_on") }}
                        i(:class="changeSortKey('created_on')")
                  tbody
                    tr(v-if="auditLogList.length == 0")
                      td(colspan="8").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in auditLogList")
                      td
                        span
                          b-link.clickable(href="javascript:void(0);" @click="onDetail(item)") {{ item.log_id }}
                      td
                        span(:title="item.status_desc") {{ item.status_desc }}
                      td
                        span(:title="item.ip_address") {{ item.ip_address }}
                      td
                        span(:title="item.sport_type + ' [' + item.sport_id + ']'") {{ item.sport_type }}
                      td
                        span(:title="item.sbo_league_name + ' [' + item.sbo_league_id + ']'") {{ item.sbo_league_name }}
                      td
                        span(:title="item.ibc_league_name + ' [' + item.ibc_league_id + ']'") {{ item.ibc_league_name }}
                      td
                        span(:title="item.action_by") {{ item.action_by }}
                      td.text-right
                        span(:title="getDate(item.created_on)") {{ getDate(item.created_on) }}
          div(v-if="pageLvl == 'detail'")
            div.row.mb-1
              div.col
                SubmitButton(
                  :loading="loading"
                  icon="icon-arrow-left"
                  :text="$t('ui.back')"
                  type="button"
                  @click="backToMasterLvl"
                  variant="secondary"
                  size="sm"
                  ).mb-1.mr-1
            div.row-mb-3
              b-form-group(:label="$t('ui.log')").mb-3
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span {{ $t("ui.id") }}
                      th.sticky-position(width="15%")
                        span {{ $t("ui.status") }}
                      th.sticky-position(width="8%")
                        span {{ $t("ui.ip_address") }}
                      th.sticky-position(width="8%")
                        span {{ $tc("ui.sports", 1) }}
                      th.sticky-position(width="22%")
                        span {{ $t("ui.sbo_league") }}
                      th.sticky-position(width="22%")
                        span {{ $t("ui.ibc_league") }}
                      th.sticky-position(width="10%")
                        span {{ $t("ui.action_by") }}
                      th.sticky-position.text-right(width="10%")
                        span {{ $t("ui.created_on") }}
                  tbody
                    tr
                      td
                        span(:title="info.log_id") {{ info.log_id }}
                      td
                        span(:title="info.status_desc") {{ info.status_desc }}
                      td
                        span(:title="info.ip_address") {{ info.ip_address }}
                      td
                        span(:title="info.sport_type + ' [' + info.sport_id + ']'") {{ info.sport_type }}
                      td
                        span(:title="info.sbo_league_name + ' [' + info.sbo_league_id + ']'") {{ info.sbo_league_name }}
                      td
                        span(:title="info.ibc_league_name + ' [' + info.ibc_league_id + ']'") {{ info.ibc_league_name }}
                      td
                        span(:title="info.action_by") {{ info.action_by }}
                      td.text-right
                        span(:title="getDate(info.created_on)") {{ getDate(info.created_on) }}
              b-form-group(:label="$t('ui.details')").mb-3
                .clusterize-scroll
                  table.tablex(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(width="5%")
                          span {{ $t('ui.detail_id') }}
                        th.sticky-position(width="7%")
                          span {{ $t('ui.league_id') }}
                        th.sticky-position(width="7%")
                          span {{ $tc("ui.sports", 1) }}
                        th.sticky-position(width="50%")
                          span {{ $t("ui.league_name") }}
                        th.sticky-position(width="8%")
                          span {{ $t("ui.sbo") }}
                        th.sticky-position(width="8%")
                          span {{ $t("ui.ibc") }}
                        th.sticky-position(width="10%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.sticky-position.text-center(width="5%")
                          span
                    tbody.clusterize-content
                      tr(v-for="item in auditLogDetailList")
                        td
                          span(:title="item.log_detail_id") {{ item.log_detail_id }}
                        td
                          span(:title="item.league_id") {{ item.league_id }}
                        td
                          span(:title="item.sport_type + ' [' + item.sport_id + ']'") {{ item.sport_type }}
                        td
                          span(:title="item.league_name") {{ item.league_name }}
                        td
                          span(:title="item.sbo_map") {{ item.sbo_map }}
                        td
                          span(:title="item.ibc_map") {{ item.ibc_map }}
                        td
                          span(:title="item.status_desc") {{ item.status_desc }}
                        td.actions
                          span
                            a.fa.fa-eye.text-primary(href="#" @click="onView(item)" :title="$t('ui.view')")
    leagueloginfo(ref="leagueLogInfo" @failed="handleFailed" :detail="detailInfo" page="mapleague")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "vue2-daterange-picker";
import leagueloginfo from "@/components/log/leagueLogInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    leagueloginfo
  },
  data: () => ({
    loading: false,
    actionType: "",
    sportType: 0,
    sportList: [],
    auditLogList: [],
    auditLogDetailList: [],
    leagueLogList: [],
    info: null,
    currentLogPage: 1,
    auditLogTotalRow: 0,
    actionBySearch: "",
    logSearch: "",
    sortKey: "created_on",
    sortType: "desc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: 'YYYY-MM-DD hh:mm A',
      useCurrent: false,
      showClear: true,
      showClose: true,
    },
    filterBy: "league_name",
    pageLvl: "master",
    detailInfo: null,
    statusSearch: '',

  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    todayWithTime() {
      let time = '23:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterdayWithTime;
    this.endDate = this.todayWithTime;
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLog(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapleaguelog
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
      return convertDateFormat;
    },
    onDetail: function(item) {
      this.pageLvl = "detail";
      this.info = item;
      this.getLogDetail(item.log_id);
    },
    onView: function(a) {
      this.detailInfo = a;
      this.$refs.leagueLogInfo.$refs.leagueLogInfoModal.show();
    },
    getLogDetail: function(logId) {
      let url = config.getMapLeagueLogDetailUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: logId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.auditLogDetailList = response.data.tbl_map_league_log_detail;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLog: function(isSearch) {
      this.pageLvl = "master";

      let url = config.getMapLeagueLogUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentLogPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapleaguelog,
        sport_id: this.sportType,
        date_from: this.startDate,
        date_to: this.endDate,
        actionBy: this.actionBySearch,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentLogPage,
        page_size: this.getPageSize,
        status: this.statusSearch == '' ? null : this.statusSearch
      };

      if (this.filterBy == "league_id") {
        json.league_id = this.logSearch;
      } else if (this.filterBy == "league_name") {
        json.league_name = this.logSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.auditLogList = response.data.tbl_map_league_log_list;
                this.auditLogTotalRow = this.auditLogList.length > 0 ? response.data.tbl_map_league_log_list[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToMasterLvl() {
      this.pageLvl = "master";
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLogPage = 1;
      this.getLog();
    },
    changedPage: function(pageNo) {
      this.currentLogPage = pageNo;
      this.getLog();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>